import * as React from 'react'
import styled from 'styled-components'

const Summary = styled.p`
  width: 100%;
  text-align: center;
  margin: 15vh auto 15vh auto;
  max-width: 850px;
  padding: 0 20px;
  box-sizing: border-box;
`

export default function ServicesSummary(props) {
    return (
        <Summary>
            For over fifteen years, Tyler has been crafting delightful digital experiences,
            working with organizations to conceptualize, build, and launch impactful
            digital products and analytics platforms.<br /><br />
            Currently, Tyler serves as VP of Digital + Analytics at <a href="https://cabinethealth.com">Cabinet Health</a>,
            where he's leading the technology vision behind the world's first plastic-free pharmacy.
        </Summary>
    )
}



// WEBPACK FOOTER //
// ./src/components/ServicesSummary.js